import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	contacts: [],
	isLoading: false,
	error: false,
};

const contactsSlice = createSlice({
	name: 'contacts',
	initialState,
	reducers: {
		storeContacts: (state, action) => {
			state.contacts = action.payload;
		},
	},
});

export const selectAllContacts = (state) => {
	return state.contacts;
};

export const { storeContacts } = contactsSlice.actions;

export default contactsSlice.reducer;
